export const propCheck = (object, prop) =>
  object
    ? Object.prototype.hasOwnProperty.call(object, prop)
    : false
